/**
 * @param preferenceCenterForm {HTMLFormElement}
 * @return {string}
 */
module.exports = function PreferenceCenter_validatePrivacyPolicy(preferenceCenterForm) {
    const privacyPolicy = preferenceCenterForm.querySelector('[name="marketingConsent"]');
    if (privacyPolicy instanceof HTMLInputElement) {
        if (privacyPolicy.required && !privacyPolicy.checked) {
            return "Please agree to the privacy policy";
        }
    }

    return "";
}